export default __webpack_public_path__ + "static/media/Grupo 23@2x.b8e33267.png";